import React from 'react';
import classNames from 'classnames';
import styles from './Heading.module.scss';

export interface HeadingProps {
	children?: React.ReactNode;
	className?: string;
	headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
	id?: string;
	style?: 'none' | 'sm' | 'md' | 'lg' | 'lg50' | 'lg75' | 'xl' | 'xl50';
}

export const UI_Heading = ({ children, className, headingLevel, id, style = 'none' }: HeadingProps) =>
	React.createElement(
		!headingLevel ? 'p' : headingLevel,
		{
			className: classNames(styles.Heading, styles[`Heading___${style}`], className),
			id,
		},
		children,
	);
